import { provideAskNaviPlugin } from './ask-navi.plugin';

/** Providers for the Ask Navi subapp (menu + routes). */
export const AskNaviModule = [...provideAskNaviPlugin()];
